module.exports = __webpack_public_path__ + "img/logo_purple.88aef48b.png";